import React from 'react';

import { CheckCircle, Error, HourglassEmpty, Visibility, VisibilityOff } from '@mui/icons-material';
import { Chip, Tooltip } from '@mui/material';

import { titleCase } from '~/utils/stringUtils';

export function CustomOfferStatusChip({ status }: { status: App.CustomOffer['status'] | string }) {
  const displayStatus = titleCase(status.replace(/_/g, ' '));

  switch (status) {
    case 'approved':
      return <Chip icon={<CheckCircle />} color="success" size="small" label={displayStatus} />;
    case 'draft':
      return <Chip icon={<HourglassEmpty />} color="warning" size="small" label={displayStatus} />;
    case 'declined':
      return <Chip icon={<Error />} color="error" size="small" label={displayStatus} />;
    default:
      return <Chip size="small" label={displayStatus} />;
  }
}

export function CustomOfferVisibilityIcon({ hiddenFromCustomer }: { hiddenFromCustomer?: boolean }) {
  const tooltipTitle = hiddenFromCustomer ? 'Not visible to customer in MyEscapes' : 'Visible to customer in MyEscapes';

  return (
    <Tooltip title={tooltipTitle}>
      {hiddenFromCustomer ? <VisibilityOff color="action" /> : <Visibility color="action" />}
    </Tooltip>
  );
}
